module.exports = __webpack_public_path__ + "img/2.ab87719a.png";